export class OptionHtmlModel {
  constructor(
    public id: string = null,
    public value: number = null,
    public label = null
  ) {}
}
